// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2025 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

import Vue from 'vue';
import { wrapResponseWithDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import { Servicelayer } from '@glittr/frontend-core/src/plugins/servicelayer';
import RequestConfig from '@glittr/frontend-core/src/plugins/servicelayer/requestConfig';
import GetPaymentStatesRequestModel from '../../model/get-payment-states-request-model';
import GetPaymentTypesRequestModel from '../../model/get-payment-types-request-model';
import GetTypesRequestModel from '../../model/get-types-request-model';
import GetSubTypesRequestModel from '../../model/get-sub-types-request-model';
import GetReminderStatesRequestModel from '../../model/get-reminder-states-request-model';
import GetRequestFormsRequestModel from '../../model/get-request-forms-request-model';
import GetRequestFormByIdRequestModel from '../../model/get-request-form-by-id-request-model';
import StringListResultModel from '../../model/string-list-result-model';
import RequestFormPagingResultModel from '../../model/request-form-paging-result-model';
import RequestFormModel from '../../model/request-form-model';

export default (service: Servicelayer) => ({
  /**  */
  async getPaymentStates(request: GetPaymentStatesRequestModel, config?: RequestConfig) {
    // eslint-disable-next-line prefer-const
    let endpointPath = (Vue.$config.values as any)['endpoints-get-payment-states'] ?? 'core/RequestForms/PaymentStates';
    const response = await service.get<any>(endpointPath, {
      ...config,
    });
    const dto = response.data.result;
    return wrapResponseWithDataRecord(StringListResultModel.toModel(dto));
  },
  /**  */
  async getPaymentTypes(request: GetPaymentTypesRequestModel, config?: RequestConfig) {
    // eslint-disable-next-line prefer-const
    let endpointPath = (Vue.$config.values as any)['endpoints-get-payment-types'] ?? 'core/RequestForms/PaymentTypes';
    const response = await service.get<any>(endpointPath, {
      ...config,
    });
    const dto = response.data.result;
    return wrapResponseWithDataRecord(StringListResultModel.toModel(dto));
  },
  /**  */
  async getTypes(request: GetTypesRequestModel, config?: RequestConfig) {
    // eslint-disable-next-line prefer-const
    let endpointPath = (Vue.$config.values as any)['endpoints-get-types'] ?? 'core/RequestForms/Types';
    const response = await service.get<any>(endpointPath, {
      ...config,
    });
    const dto = response.data.result;
    return wrapResponseWithDataRecord(StringListResultModel.toModel(dto));
  },
  /**  */
  async getSubTypes(request: GetSubTypesRequestModel, config?: RequestConfig) {
    // eslint-disable-next-line prefer-const
    let endpointPath = (Vue.$config.values as any)['endpoints-get-sub-types'] ?? 'core/RequestForms/SubTypes';
    const response = await service.get<any>(endpointPath, {
      ...config,
    });
    const dto = response.data.result;
    return wrapResponseWithDataRecord(StringListResultModel.toModel(dto));
  },
  /**  */
  async getReminderStates(request: GetReminderStatesRequestModel, config?: RequestConfig) {
    // eslint-disable-next-line prefer-const
    let endpointPath = (Vue.$config.values as any)['endpoints-get-reminder-states'] ?? 'core/RequestForms/ReminderStates';
    const response = await service.get<any>(endpointPath, {
      ...config,
    });
    const dto = response.data.result;
    return wrapResponseWithDataRecord(StringListResultModel.toModel(dto));
  },
  /**  */
  async getRequestForms(request: GetRequestFormsRequestModel, config?: RequestConfig) {
    const requestDTO = GetRequestFormsRequestModel.toDTO(request);
    // eslint-disable-next-line prefer-const
    let endpointPath = (Vue.$config.values as any)['endpoints-get-request-forms'] ?? 'core/RequestForms';
    const response = await service.get<any>(endpointPath, {
      query: {
        from: requestDTO.from,
        until: requestDTO.until,
        type: requestDTO.type,
        subType: requestDTO.subType,
        state: requestDTO.state,
        paymentType: requestDTO.paymentType,
        paymentState: requestDTO.paymentState,
        reminderState: requestDTO.reminderState,
        searchCriteria: requestDTO.searchCriteria,
        'paging.CurrentPage': requestDTO['paging.CurrentPage'],
        'paging.PageSize': requestDTO['paging.PageSize'],
        'paging.IncludeCount': requestDTO['paging.IncludeCount'],
        'paging.NoPaging': requestDTO['paging.NoPaging'],
      },
      ...config,
    });
    const dto = response.data.result;
    return wrapResponseWithDataRecord(RequestFormPagingResultModel.toModel(dto));
  },
  /**  */
  async getRequestFormById(request: GetRequestFormByIdRequestModel, config?: RequestConfig) {
    const requestDTO = GetRequestFormByIdRequestModel.toDTO(request);
    // eslint-disable-next-line prefer-const
    let endpointPath = (Vue.$config.values as any)['endpoints-get-request-form-by-id'] ?? 'core/RequestForms/{id}';
    endpointPath = endpointPath.replace(/\{id\}/g, `${requestDTO.id}`);
    const response = await service.get<any>(endpointPath, {
      ...config,
    });
    const dto = response.data.result;
    return wrapResponseWithDataRecord(RequestFormModel.toModel(dto));
  },
});
